import React from "react";

const OvalSpinner = ({ size = 24, color = "currentColor" }) => {
  // Ensure square sizing and prevent flex-based stretching that can turn the circle into an oval.
  const px = (v) => (typeof v === 'number' ? `${v}px` : v);
  return (
    <span
      style={{
        display: 'inline-block',
        width: px(size),
        height: px(size),
        minWidth: px(size),
        minHeight: px(size),
        boxSizing: 'border-box',
        flex: '0 0 auto',
        aspectRatio: '1 / 1',
        border: `3px solid ${color}`,
        borderRadius: '50%',
        borderTop: `3px solid transparent`,
        animation: 'spin 0.8s linear infinite',
        verticalAlign: 'middle',
      }}
    />
  );
};

export default OvalSpinner;